import getItem from 'owa-mail-store/lib/services/getItem';
import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import ItemResponseShape from 'owa-service/lib/contract/ItemResponseShape';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import AdjacentAndConflictingMeetingData from '../store/schema/AdjacentAndConflictingMeetingData';
import RequestOptions from 'owa-service/lib/RequestOptions';

function getItemAdjacentAndConflictingMeetingsResponseShape(): ItemResponseShape {
    return itemResponseShape({
        BaseShape: 'IdOnly',
        AdditionalProperties: [
            propertyUri({ FieldURI: 'ConflictingMeetings' }),
            propertyUri({ FieldURI: 'AdjacentMeetings' }),
        ],
    });
}

function processResponseMessage(
    responseMessage: SingleResponseMessage[]
): AdjacentAndConflictingMeetingData {
    if (checkIfResponseSuccess(responseMessage[0])) {
        const responseItem = responseMessage[0] as ItemInfoResponseMessage;
        const calendarItem = responseItem.Items[0] as CalendarItem;
        return {
            conflictingMeetings: calendarItem.ConflictingMeetings,
            adjacentMeetings: calendarItem.AdjacentMeetings,
        };
    }
    return null;
}

export default function loadAdjacentAndConflictingMeetings(
    itemId: string,
    options?: RequestOptions
): Promise<AdjacentAndConflictingMeetingData> {
    return getItem(
        [itemId],
        getItemAdjacentAndConflictingMeetingsResponseShape(),
        null,
        'V2016_06_24',
        options
    ).then(responseMessage => {
        return processResponseMessage(responseMessage);
    });
}
